import { Suspense, lazy } from "react";
import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/signUp/main"));

const SignUp = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default SignUp;
